<template>
  <div v-if="total > 0" class="notif-indicator" ref="rootRef">
    <button
      class="notif-btn"
      :class="{ 'notif-btn--collapsed': collapsed }"
      :title="collapsed ? `${total} pendência(s)` : undefined"
      @click="open = !open"
    >
      <Bell :size="16" class="notif-icon" />
      <span class="notif-count">{{ total > 99 ? '99+' : total }}</span>
      <span v-if="!collapsed" class="notif-label">Pendências</span>
    </button>

    <div v-if="open" class="notif-dropdown">
      <button
        v-for="s in pending"
        :key="s.key"
        class="notif-item"
        @click="goTo(s)"
      >
        <span class="notif-item-label">{{ s.label }}</span>
        <span class="notif-item-count">{{ s.count > 99 ? '99+' : s.count }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { Bell } from 'lucide-vue-next'
import { useNotificationSources } from '@/notifications/registry'

export default {
  name: 'NotificationIndicator',
  components: { Bell },
  props: {
    userRole: { type: String, required: true },
    collapsed: { type: Boolean, default: false },
  },
  setup(props) {
    const router = useRouter()
    const { pending, total } = useNotificationSources(props.userRole)
    const open = ref(false)
    const rootRef = ref(null)

    function goTo(source) {
      open.value = false
      router.push({ name: source.route, query: source.query })
    }

    function onClickOutside(e) {
      if (rootRef.value && !rootRef.value.contains(e.target)) open.value = false
    }

    onMounted(() => document.addEventListener('click', onClickOutside))
    onUnmounted(() => document.removeEventListener('click', onClickOutside))

    return { pending, total, open, rootRef, goTo }
  },
}
</script>

<style scoped>
.notif-indicator {
  position: relative;
  margin: 8px 10px 2px;
  flex-shrink: 0;
}

.notif-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  width: 100%;
  padding: 6px 10px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  cursor: pointer;
  color: #b91c1c;
  font-size: 12px;
  font-weight: 600;
}

.notif-btn--collapsed {
  justify-content: center;
  padding: 6px;
}

.notif-icon { flex-shrink: 0; }

.notif-count {
  background: #ef4444;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  line-height: 1;
}

.notif-label { flex: 1; text-align: left; }

.notif-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 40;
  overflow: hidden;
}

.notif-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 9px 12px;
  background: none;
  border: none;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
  font-size: 12.5px;
  color: #374151;
  text-align: left;
}

.notif-item:last-child { border-bottom: none; }
.notif-item:hover { background: #f9fafb; }

.notif-item-count {
  background: #ef4444;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  flex-shrink: 0;
}
</style>
